import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { HeroAccentUnderlineHost } from '@/components/marketing/hero-accent-underline';

/**
 * The italic-serif design signature. Renders a span carrying the `.italic-serif`
 * rule from globals.css (Instrument Serif italic with the 2px optical baseline
 * lift) plus, by default, the brand-blue gradient text fill that makes the
 * accent shimmer against the dark bg. Pass `gradient={false}` for a flat-white
 * variant when context calls for it.
 *
 * `withUnderline` wraps the text in a hover-tracked host that draws a scribble
 * underline SVG path below the word — used exclusively on the hero headline
 * accent. The gradient-text behaviour is unchanged.
 */
export function TextAccent({
  children,
  className,
  gradient = true,
  withUnderline = false,
}: {
  children: ReactNode;
  className?: string;
  gradient?: boolean;
  withUnderline?: boolean;
}) {
  const inner = (
    <span className={cn('italic-serif', gradient && 'grad-text', className)}>
      {children}
    </span>
  );

  if (withUnderline) {
    return <HeroAccentUnderlineHost>{inner}</HeroAccentUnderlineHost>;
  }

  return inner;
}
